import "core-js/modules/es.array.push.js";
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { rqtGetUserWechatUpdateEmailSms, rqtGetUserWechatCheckEmailSms } from '@/services/common';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      validateCode: undefined,
      mobile: undefined,
      openId: undefined,
      customerDetail: {},
      customerAddress: {
        pcc: '',
        street: ''
      }
    };
  },
  computed: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.mobile = this.$route.query.mobile;
    },
    //获取验证码
    getCodeClick() {
      this.codeLoading = true;
      rqtGetUserWechatUpdateEmailSms({
        mobile: this.mobile
      }).then(() => {
        // const resData = res.data.data
        this.$notify({
          message: '验证码已发送',
          type: 'success'
        });
        this.codeLoading = false;
      }).catch(() => {
        this.codeLoading = false;
      });
    },
    beginUpdate() {
      if (!this.validateCode) {
        this.$notify({
          message: '验证码不能为空',
          type: 'warning'
        });
        return;
      }
      rqtGetUserWechatCheckEmailSms({
        mobile: this.mobile,
        validateCode: this.validateCode
      }).then(() => {
        this.$router.push('/wx/updateEmail/personal');
      }).catch(err => {
        console.error(err);
        this.$notify({
          message: '验证码填写不正确',
          type: 'danger'
        });
      });
    }
  }
};